import { userLogin, getPreference, userLogOut, migrateGuestSearchHistory, getProfileCompletion, postPanelResult, getCvsDetails } from "../utils/apiFunction";
import { getProcessedToken } from "../utils/request";
import { COOKIE_OPTIONS_SUFFIX } from "@/utils/cookieConfig.js";
import config from "../utils/config";
import { clearCookies, getGuestUUID, clearGuestUUID, ensureGuestUUID } from "@/utils/helpers";
const qs = require("qs");
import router, { resetRouter } from "@/router";

const state = {
  candAccess: false,
  accessToken: "",
  refreshToken: "",
  userData: {},
  preference: {},
  recruitment: {},
  assessment: {},
  candidate: {},
  training: {},
  loginStatus: false,
  userName: "",
  college: {},
  resumeClinicuuid: null,
  resumeJobid: null,
  newUseruuid: null,
  profileProgress: false,
  downloadReport: true,
  userProfileData: {},
  loginType: "",
};

const getters = {
  getDownloadReport: (state) => state.downloadReport,
  checkProfileProgress: (state) => state.profileProgress,
  getCandAccess: (state) => state.candAccess,
  getAccessToken: (state) => state.accessToken,
  getRefreshToken: (state) => state.refreshToken,
  getUserData: (state) => state.userData,
  getLoginStatus: (state) => state.loginStatus,
  getUserName: (state) => state.userName,
  getResumeuuid: (state) => state.resumeClinicuuid,
  getResumejobid: (state) => state.resumeJobid,
  getNewUseruuid:  (state) => state.newUseruuid,
  getUserProfileData: (state) => state.userProfileData,
};

const mutations = {
  setDownloadReport(state, val){
    state.downloadReport = val;
  },
  setProfileProgress(state, val){
    state.profileProgress = val;
  },
  setCandAccess(state, payload) {
    state.candAccess = payload;
  },
  setToken(state, token) {
    state.accessToken = token;
  },
  setRefreshToken(state, token) {
    state.refreshToken = token;
  },
  setUserData(state, data) {
    state.userData = data;
  },
  setPreference(state, data) {
    state.preference = data;
  },
  setRecruitment(state, data) {
    state.recruitment = data;
  },
  setAssessment(state, data) {
    state.assessment = data;
  },
  setCandidate(state, data) {
    state.candidate = data;
  },
  setTraining(state, data) {
    state.training = data;
  },
  setLoginStatus(state, val) {
    state.loginStatus = val;
  },
  setUserName(state, val) {
    state.userName = val;
  },
  setCollege(state, val) {
    state.college = val;
  },
  setresumeJobid(state, jobId) {
    state.resumeJobid = jobId;
  },
  setresumeClinicuid(state, uuid) {
    state.resumeClinicuuid = uuid;
  },
  setNewUseruuid(state, uuid) {
    state.newUseruuid = uuid;
  },
  setProfileData(state, data){
    state.userProfileData = data;
  },
  setLoginType(state, type) {
    state.loginType = type;
    try {
      const savedStateStr = localStorage.getItem("simpAdminState");
      let savedState = savedStateStr ? JSON.parse(savedStateStr) : {};
      if (!savedState.userVUEX) {
        savedState.userVUEX = {};
      }
      savedState.userVUEX.loginType = type;
      localStorage.setItem("simpAdminState", JSON.stringify(savedState));
    } catch (e) {
      console.error("Failed to save loginType to localStorage", e);
    }
  },
};

const actions = {
  /**
   * Login via Keycloak SSO.
   * Expects payload: { keycloak: qs.stringify({...}), username: '...' }
   */
  async login({ commit }, payload) {
    const response = await userLogin(payload.keycloak);
    commit("setToken", response.data.access_token);
    commit("setRefreshToken", response.data.refresh_token);
    return response;
  },

  /**
   * Saves access cookies and redirects user based on project access.
   * data: { details, flag, loginData, mobaccess? }
   */
  async saveAccess({ state, commit, dispatch }, data) {
    const { details, flag, loginData, redirectUrl } = data;
    // Use guest UUID from cookies (read after tokens/cookies are set)

    // Build cookie expiry
    // const expiry = "Wed, 16 Jan 2030 12:00:00 UTC";
    // const domain = "simplifymycareer.com";

    // Core projects to check against
    const coreProjects = [
      "recruitment",
      "assessment",
      "candidate",
      "training",
      "collegeDashboard",
    ];

    // Set 'no-access' cookie for any core project NOT present in the details array
    coreProjects.forEach((projName) => {
      const hasProject = details.some((p) => p.project === projName);
      if (!hasProject) {
        document.cookie = `${projName}=no-access;${COOKIE_OPTIONS_SUFFIX}`;
      }
    });

    // Save each active project as a cookie
    details.forEach((project) => {
      document.cookie = `${project.project}=${JSON.stringify(
        project,
      )};${COOKIE_OPTIONS_SUFFIX}`;
    });
    let loginDataVal = {...loginData, clearStore: true}
    // Save loginData cookie
    document.cookie = `loginData=${JSON.stringify(
      loginDataVal,
    )};${COOKIE_OPTIONS_SUFFIX};`;
    // document.cookie = `loginData=${JSON.stringify(loginData)};expires=${expiry};path=/;domain=${domain};`;

    // Save tokens
    if (state.accessToken) {
      document.cookie = `accessToken=${state.accessToken};${COOKIE_OPTIONS_SUFFIX}`;
    }
    if (state.refreshToken) {
      document.cookie = `refreshToken=${state.refreshToken};${COOKIE_OPTIONS_SUFFIX}`;
    }
    commit("setCandAccess", true);
    commit("setLoginStatus", true);

    // Migrate guest search history now that tokens/cookies are set
    try {
      const guestUUID = getGuestUUID();
      if (guestUUID) {
        await migrateGuestSearchHistory(guestUUID);
        clearGuestUUID();
      }
    } catch (error) {
      console.error("Guest migration failed:", error);
      try {
        clearGuestUUID();
      } catch (e) {
        /* ignore */
      }
    }    

    dispatch("goToPage", { project: flag, details, redirectUrl });
  },

  async goToPage({ commit, getters }, payload) {
    const { project, details, loggedIn, redirectUrl } = payload;
    const isLaptop = window.innerWidth > 1028;
    
    // Remove 'redirect' query parameter before ANY redirection
    try {
      const urlObj = new URL(window.location.href);
      if (urlObj.searchParams.has("redirect")) {
        urlObj.searchParams.delete("redirect");
        window.history.replaceState({}, document.title, urlObj.toString());
      }
    } catch (e) {
      console.error("Failed to strip redirect query param", e);
    }

    const performRedirect = (targetUrl) => {
      const type = targetUrl.includes(config.candidateBase) ? "candidate" : "admin";
      commit("setLoginType", type);
      window.location.href = targetUrl;
    };

    if (redirectUrl) {
      // window.location.replace(redirectUrl);
      performRedirect(redirectUrl);
      return;
    }
    // Try fetching preferences if this is an admin login
    const redirectFlag = project;
    let finalRedirectFlag = redirectFlag;

    if (redirectFlag !== "candidate" && details.length != 1 && isLaptop) {
      try {
        const prefRes = await getPreference();
        if (
          prefRes &&
          prefRes.status === 200 &&
          prefRes.data &&
          prefRes.data.data
        ) {
          const prefData = prefRes.data.data;
          commit("setPreference", prefData);
          if (
            prefData.defaultModule &&
            prefData.defaultModule !== "candidate"
          ) {
            finalRedirectFlag = prefData.defaultModule;
          }
        }
        console.log(prefRes.data);
      } catch (e) {
        console.error("Failed to fetch user preference", e);
      }
    }

    // If it's an admin login and no preference was found, find the first project
    // they have access to (other than candidate).
    if (finalRedirectFlag === "admin" && details && details.length > 0) {
      const activeProjects = details.filter((p) => {
        return p.userPermissions ? p.userPermissions.isActive : p.isActive;
      });
      let defaultProject;
      if (loggedIn) {
        // Not from modal: prefer candidate if access exists, else first active project
        const candidateProject = activeProjects.find((p) => p.project === "candidate");
        if (candidateProject) {
          finalRedirectFlag = "candidate";
        } else {
          defaultProject = activeProjects.find((p) => p.project !== "candidate");
          if (defaultProject) finalRedirectFlag = defaultProject.project;
        }
      } else {
        // From modal: find the first non-candidate project
        defaultProject = activeProjects.find((p) => p.project !== "candidate");
        if (defaultProject) finalRedirectFlag = defaultProject.project;
      }
    }

    if (finalRedirectFlag && finalRedirectFlag !== "candidate" && finalRedirectFlag !== "admin") {
      try {
        localStorage.setItem("lastAdminProject", finalRedirectFlag);
      } catch (e) {
        console.error("Failed to save lastAdminProject to localStorage", e);
      }
    }

    // Redirect based on flag
    const projectUrls = {
      recruitment: config.recruitment,
      assessment: config.assessment,
      candidate: config.candidateBase,
      training: config.trainingAdminBase,
      collegeDashboard: config.collegeDashboard,
    };
    let url = projectUrls[finalRedirectFlag];
    let pendingRoadmapUrl = "";

    if (finalRedirectFlag === "candidate") {
      try {
        const currentUrl = new URL(window.location.href);
        const pendingSkillsRaw = currentUrl.searchParams.get("roadmapSkills");
        const pendingSkills = pendingSkillsRaw ? JSON.parse(pendingSkillsRaw) : [];
        const normalizedSkills = Array.isArray(pendingSkills)
          ? pendingSkills
            .map((skill) => (typeof skill === "string" ? skill.trim() : ""))
            .filter((skill) => !!skill)
          : [];

        if (normalizedSkills.length) {
          const targetUrl = new URL(`${config.candidateBase}/interviewskill/?from=candidate`);
          targetUrl.searchParams.set(
            "roadmapSkills",
            JSON.stringify(normalizedSkills),
          );
          targetUrl.searchParams.set(
            "interviewPage",
            true,
          );
          pendingRoadmapUrl = targetUrl.toString();
        }
      } catch (error) {
        console.error("Failed to parse pending roadmap skills", error);
      }
    }

    if (finalRedirectFlag === "candidate" && getters.getResumeuuid) {
      const newUser = getters.getNewUseruuid;
      const uuid = getters.getResumeuuid;
      if(newUser){
        commit("setNewUseruuid", null);
        commit("setresumeClinicuid", null);
        commit("setresumeJobid", null);
        if(getters.getDownloadReport){
          commit("setDownloadReport", false);
          performRedirect(`${config.candidateBase}/dashboard/?from=candidate&fromWebsite=true&downloadReport=true&uuid=${uuid}`);
        }
        else{
          performRedirect(`${config.candidateBase}/dashboard/?from=candidate&fromWebsite=true&openResumeClinic=true&uuid=${uuid}`);
        }
      }
      else if (getters.getResumejobid && getters.getResumeuuid) {
        const jobURL = `${config.candidateBase}/job/search/?from=candidate&interviewPage=true`;
        const jobid = getters.getResumejobid;
        commit("setresumeClinicuid", null);
        commit("setresumeJobid", null);
        // window.location.replace(
        //   `${jobURL}&jobID=${jobid}&uuid=${uuid}`
        // );
        performRedirect(`${jobURL}&jobID=${jobid}&uuid=${uuid}`);
      }
      else if (getters.getResumeuuid) {
        const cvURL = `${config.candidateBase}/dashboard?from=candidate`;
        const uuid = getters.getResumeuuid;
        commit("setresumeClinicuid", null);
        // window.location.replace(
        //   `${cvURL}&uuid=${uuid}`
        // );
        if(getters.getDownloadReport){
          commit("setDownloadReport", false);
          performRedirect(`${cvURL}&uuid=${uuid}&downloadReport=true`);
        }
        else{
          performRedirect(`${cvURL}&uuid=${uuid}&openResumeClinic=true`);
        }
      }
    }
    else if (pendingRoadmapUrl) {
      // window.location.replace(pendingRoadmapUrl);
      performRedirect(pendingRoadmapUrl);
    }
    else if(getters.checkProfileProgress === true){
      commit("setProfileProgress", false);
      const response = await getProfileCompletion();
      if (response.status === 200) {
        const progress = response.data.data.progress || 0;
        if (progress < 70) {
          performRedirect(`${config.candidateBase}/homepage?showSeventyPercentModal=true`);
        } else {
          let startedNow = false;
          let results = "";

          try {
            const payload = { userID: getProcessedToken() };
            const panelRes = await postPanelResult(payload);
            if (panelRes && panelRes.status === 200) {
              results = panelRes.data.data.result;
            }
          } catch (error) {
            console.error("Error fetching panel results in Vuex:", error);
          }
          try {
            const panelStat = await getCvsDetails();
            if (panelStat && panelStat.status === 200) {
              startedNow = true;
            }
          } catch (error) {
            console.error("Error fetching getCvsDetails:", error);
          }

          if (results === "selected" || results === "rejected") {
            results = "";
            performRedirect(`${config.candidateBase}/resultdashboard?from=candidate`);
          } else {
            if (startedNow) {
              startedNow = false;
              performRedirect(`${config.candidateBase}/applicationresult?from=candidate`);
            } else {
              performRedirect(`${config.candidateBase}/becomepanelist?from=candidate`);
            }
          }
        }
      }
      else performRedirect(`${config.candidateBase}/homepage?showSeventyPercentModal=true`);
    }
    else {
      if (finalRedirectFlag === "candidate") {
        url = `${url}?from=candidate`;
      }
      // window.location.replace(url);
      performRedirect(url);
      // location.href = url;
    }
  },

  LogOut({ commit, state }) {
    const resetClientState = () => {
      clearCookies();      
      commit("setToken", "");
      commit("setRefreshToken", "");
      commit("setCandAccess", false);
      commit("setUserData", {});
      commit("setPreference", {});
      commit("setRecruitment", {});
      commit("setAssessment", {});
      commit("setCandidate", {});
      commit("setTraining", {});
      commit("setLoginStatus", false);
      commit("setUserName", "");
      commit("setCollege", {});
      commit("setresumeClinicuid", null);
      commit("setresumeJobid", null);
      commit("setNotifOpen", false, { root: true });
      commit("setSkillsModalOpen", false, { root: true });
      commit("setLoginPage", "", { root: true });
      commit("setLoginType", "");
      localStorage.clear();
      ensureGuestUUID();
    };

    const refreshToken = state.refreshToken;
    const accessToken = state.accessToken;

    resetRouter();
    return userLogOut(
      qs.stringify({
        client_id: "vue-test-app",
        refresh_token: refreshToken,
      }),
      {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        Authorization: `Bearer ${accessToken}`,
      }
    )
      .then((response) => {
        resetClientState();
        router.push({ path: '/' });
        return response;
      })
      .catch(() => {
        resetClientState();
        router.push({ path: '/' });
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
